module.exports = __webpack_public_path__ + "img/qygl4.0b772b02.jpg";